import LLMap from "@ogaf/map.scripts/MapTypes/LLMap";
import TrateSelectionMap from "./TrateSelectionMap";

declare global {
    var OGMap: TrateSelectionMap;
    function initMap(): void;
}

globalThis.initMap = () => {
    globalThis.OGMap = new TrateSelectionMap(new LLMap());
}
